import { render, staticRenderFns } from "./SelectSignMethod.vue?vue&type=template&id=1457b154"
import script from "./SelectSignMethod.vue?vue&type=script&lang=js"
export * from "./SelectSignMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports